define('../app/fukit/configuration/navigation.configuration',['require','exports','module','underscore','../config','backbone.radio','../helpers/route.helper','../helpers/roles.helper','../behavior/authorization.behavior','../behavior/hide.menu.item.with.empty.sub.menu.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                                    = require('underscore'),
      config                               = require('../config'),
      Radio                                = require('backbone.radio'),
      RouteHelper                          = require('../helpers/route.helper'),
      RolesHelper                          = require('../helpers/roles.helper'),

      // behaviors
      AuthorizationBehavior                = require('../behavior/authorization.behavior'),
      HideMenuItemWithEmptySubMenuBehavior = require('../behavior/hide.menu.item.with.empty.sub.menu.behavior');

  var NavigationConfiguration = {
    radioRequests: {
      'navigationConfiguration items': 'getNavigationItems',
    },

    radioEvents: {
      // in order to avoid a race condition where the we try to apply provision enabling conditions before the tenant model
      // has been fetched, we don't build the menu now until onAppReady.  Since permissions are evaluated on a view's first
      // render, we don't risk any authorization issues.
      'app ready': 'onAppReady',
    },

    options: {
      navigation: { items: [] },
    },

    onAppReady: function() {
      appNavigation = this.options.navigation;
      this.items = _.map(appNavigation.items, this.processNavigationItem, this);
    },

    processNavigationItem: function(item) {
      //prettier-ignore
      var option    = RolesHelper.getMatchedOption([item.enableOnlyWhen, item.visibleOnlyWhen, item.setTextWhen]),
          isAllowed = (option && option.roles) ? RolesHelper.evaluateRolesOptions(option.roles) : true;

      item = _.extend({}, item);

      if (_.isString(item.image)) {
        item.image = config.replaceVariables(item.image);
        this.attachAuthorizationBehavior(item);
      }
      if (_.isString(item.link)) {
        if (isAllowed) {
          item.link = config.replaceVariables(item.link);
        } else {
          delete item.link;
        }
        this.attachAuthorizationBehavior(item);
      }
      if (_.isString(item.route)) {
        if (isAllowed) {
          item.link = RouteHelper.resolve(item.route, item.params);
        }
        this.attachAuthorizationBehavior(item);
      }
      if (_.isArray(item.children)) {
        if (isAllowed) {
          // add styling to the definition for a
          // menu item with children

          /* NOTE: platform, sp, admin, coi, iacuc have `item.tree = true`, landing page and profile use 'item.subMenu = true'. UX confirmed that item.tree is the "default" UI. See App-template commits 286b8d5 and 1e7e214 for more info */
          item.tree = true;
          // item.subMenu = true;
          item.inline = true;
          item.children = _.map(item.children, this.processNavigationItem, this);
          this.attachEmptySubMenuBehavior(item);
        } else {
          item.visible = false;
        }
      }

      return item;
    },

    attachAuthorizationBehavior: function(item) {
      item.behaviors = _.extend(
        {
          AuthorizationBehavior: {
            enableOnlyWhen: item.enableOnlyWhen,
            visibleOnlyWhen: item.visibleOnlyWhen,
            setTextWhen: item.setTextWhen,
            behaviorClass: AuthorizationBehavior,
          },
        },
        item.behaviors
      );
    },

    attachEmptySubMenuBehavior: function(item) {
      item.behaviors = _.extend(
        {
          HideMenuItemWithEmptySubMenuBehavior: {
            behaviorClass: HideMenuItemWithEmptySubMenuBehavior,
          },
        },
        item.behaviors
      );
    },

    getNavigationItems: function() {
      return this.items;
    },
  };
  module.exports = NavigationConfiguration;
});

